<template>
  <div class="BS-slide view-slide">
    <img :src="cardBgImg" />
    <div class="slide-text-part">
      <img v-if="logo" :src="cardLogo" v-on:click="select($event)" />
      <h3 class="card-name" v-if="!logo" v-on:click="select($event)">
        {{ name }}
      </h3>
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>
        {{ title }}<br v-if="title" />
        <span v-html="description"></span>
      </p>
      <div class="text-center">
        <button v-on:click="select($event)">
          OPEN APP <img :src="arrowImg" />
        </button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "AppCardComponent",
  props: ["name", "title", "description", "bgImg", "logo"],
  computed: {
    cardLogo: function () {
      return `${process.env.VUE_APP_CARD_IMG_PATH}${this.logo}`;
    },
    cardBgImg: function () {
      return `${process.env.VUE_APP_CARD_IMG_PATH}${this.bgImg}`;
    },
    arrowImg: function () {
      return `${process.env.VUE_APP_CARD_IMG_PATH}${this.$store.state.style["--arrow_image"]}`;
    },
  },
};
</script>

<style>
.card-name {
  letter-spacing: 0px !important;
  font-weight: normal;
}
.card-name span {
  font-weight: bold;
}
</style>
